import { createContext, useEffect, useState } from "react";
import apiClient from "../lib/api_client";

export const SalesPersonIdContext = createContext();

export const SalesPersonIdProvider = ({ children }) => {
  const [salesPersonId, setSalesPersonId] = useState(null);

  const findSalesPersonId = async () => {
    try {
      const res = await apiClient.get("/");
      return res?.data?.salesPersonId;
    } catch (error) {
      console.log("error ---->", error?.message);
    }
  };

  useEffect(() => {
    findSalesPersonId()
      .then((res) => {
        setSalesPersonId(res);
      })
      .catch((error) => {
        console.log("error --->", error.message);
      });
  }, []);
  return (
    <SalesPersonIdContext.Provider value={{ salesPersonId }}>
      {children}
    </SalesPersonIdContext.Provider>
  );
};
